/**
 * @Description 智擎工作台本地卡片组件统一注册表
 * 运行时通过 resolveLocalComponent(name) 查询组件。
 * 卡片列表「npm组件名」字段填写的值必须与这里的导出名一致。
 */
import * as commonCards from './components/index.js'
import * as cfoCards from './cfo/components/index.js'
import * as csoCards from './cso/components/index.js'
import * as energyCards from './energy/components/index.js'

const registry = {
  ...commonCards,
  ...cfoCards,
  ...csoCards,
  ...energyCards
}

/**
 * 根据组件名查询本地卡片组件
 * @param {string} name 卡片市场 npmName 字段值
 * @returns {VueComponent|null}
 */
export function resolveLocalComponent(name) {
  if (!name) return null
  return registry[name] || null
}

/** 当前所有已注册的本地卡片组件名 */
export const LOCAL_COMPONENT_NAMES = Object.keys(registry)

/** 本地组件总数（便于日志/调试） */
export const LOCAL_COMPONENT_COUNT = LOCAL_COMPONENT_NAMES.length

export default registry
